<template>
  <section class="c-section c-section--membership">
    <div class="c-container-membership">
      <div class="container">
        <div class="p-lg-5 mb-5">
          <b-skeleton-wrapper :loading="memberships.loading">
            <template #loading>
              <section class="py-5 my-5">
                <div class="row justify-content-center gx-5 gy-5">
                  <div class="col-12 col-md-6 col-lg-5">
                    <b-skeleton height="500px"></b-skeleton>
                  </div>
                  <div class="col-12 col-md-6 col-lg-5">
                    <b-skeleton height="500px"></b-skeleton>
                  </div>
                </div>
              </section>
            </template>

            <div class="row justify-content-center">
              <div class="col-12 col-md-10">
                <div class="d-flex flex-column pt-5 flex-md-row w-100 mb-5">
                  <div v-if="!isAlreadyMonthSubsriber" class="w-100 mb-5 mb-md-0">
                    <MembershipCard
                      variant="fresh"
                      plan="month"
                      :body="memberships.data.month"
                      :subscriber="userSubscriber"
                    />
                  </div>
                  <div class="w-100">
                    <MembershipCard
                      plan="anual"
                      :body="memberships.data.anual"
                      :subscriber="userSubscriber"
                    />
                  </div>
                </div>
                <div v-if="benefitPremium">
                  <h2 class="white fs-25 w-sbold mb-4">
                    Beneficios siendo premium
                  </h2>
                  <ul class="ul-reset">
                    <li
                      v-for="(ben, iben) in benefitPremium"
                      :key="iben"
                      class="mb-3 c-membership__ul"
                      :class="{'active-bg' : iben%2==1}"
                    >
                      <p class="gray-light fs-16 d-flex align-items-start mb-0">
                        <span class="c-membership__vector me-2">
                          <Icon icon="akar-icons:circle-check" />
                        </span>
                        {{ ben.benefit }}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </b-skeleton-wrapper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      benefitPremium: [],
      memberships: {
        data: {
          month: null,
          anual: null,
        },
        loading: true,
      },

      userSubscriber: false,
    };
  },
  components: {
    MembershipCard: () => import(/* webpackChunkName: "membership-card" */'../components/MembershipCard.vue'),
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userAuthToken() {
      return this.$store.getters.token;
    },
    userData() {
      return this.$store.getters.stateUser;
    },

    isAlreadyMonthSubsriber() {
      return (this.isAuthenticated)
        ? this.userData.subscriber && this.userData.subscriber_plan === 'month'
        : false;
    },
  },
  created() {
    this.getMemberships();
  },
  methods: {
    getMemberships() {
      const request = `${process.env.VUE_APP_API}/memberships`;

      this.memberships.loading = true;

      fetch(request, {
        headers: {
          ...(this.isAuthenticated && { Authorization: `Bearer ${this.userAuthToken}` }),
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            const membershipMonth = response.data.month;
            const membershipAnual = response.data.anual;
            this.benefitPremium = response.data.benefits;

            this.memberships.data = {
              month: {
                title: 'MENSUAL',
                has_discount: membershipMonth.has_discount,
                discount: Number(membershipMonth.amount_before)
                  - Number(membershipMonth.amount_current),
                amounts: {
                  before: Number(membershipMonth.amount_before),
                  current: Number(membershipMonth.amount_current),
                  symbol: membershipMonth.symbol,
                },
                button: {
                  path: '/checkout/membership?plan=month',
                  name: 'Comprar Plan Mensual',
                },
                description: membershipMonth.description,
                benefits: membershipMonth.benefits,
              },
              anual: {
                ...this.membershipAnual,
                title: 'ANUAL',
                has_discount: membershipAnual.has_discount,
                discount: Number(membershipAnual.amount_before)
                  - Number(membershipAnual.amount_current),
                amounts: {
                  before: Number(membershipAnual.amount_before),
                  current: Number(membershipAnual.amount_current),
                  symbol: membershipAnual.symbol,
                },
                button: {
                  path: '/checkout/membership?plan=anual',
                  name: 'Comprar Plan Anual',
                },
                description: membershipAnual.description,
                benefits: membershipAnual.benefits,
              },
            };

            this.userSubscriber = response.subscriber;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.memberships.loading = false;
        });
    },
  },
};
</script>
